import styled from "styled-components";

export const Container = styled.div`
  max-height: 312px;
  padding: 27px 21px 17px 40px;
  overflow-y: auto;
  overflow-x: hidden;

  .titleTab {
    font-size: 14px;
    font-weight: 600;
    line-height: 19px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }

  .disciplinasList {
    padding-top: 10px;
  }

  .novaDisciplinaContainer {
    padding-top: 15px;
  }

  .formNovaDisciplina {
    display: flex;
    padding-top: 15px;

    > :first-child{
      flex: 1;
      margin-right: 18px;
    }

    .titleButton {
      padding: 0 20px;
    }
  }
`;
